import { z } from "zod";

// TODO: Align options with ArtifactSchema minus "unknown"
export const AiGenerationType = z.enum([
  "low_fidelity_wireframe",
  "high_fidelity_wireframe",
  "high_fidelity_ui",
]);
export type AiGenerationType = z.infer<typeof AiGenerationType>;
